import React from "react";

export const MenuIcons = [
  "#ac",
  "#at",
  "#contact-icon",
  "#to-top-icon",
  "#burger",
];

export const ATiconOld = (props) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 25 25"
      fill="currentcolor"
      {...props}
    >
      <g transform="translate(-17.12 -14.895)">
        <path d="M19.1,19.9H30v3.8h-1.5v-2.3h-3v11.6h2.3v1.6h-6.3v-1.6h2.3V21.5h-3v2.3h-1.6V19.9z" />
        <g transform="translate(33.572 28.843) rotate(90)">
          <path d="M6.5-3.4c0.1,0.1,0.1,0.3,0,0.4c0,0,0,0,0,0L2.8,0.1c-0.1,0.1-0.3,0.1-0.4,0 C2.3,0,2.3,0,2.3-0.1v-6.2c0-0.2,0.1-0.3,0.3-0.3c0.1,0,0.1,0,0.2,0.1L6.5-3.4z" />
          <path d="M-6.7-3.2L-6.7-3.2c0-0.4,0.3-0.7,0.7-0.7H4.5c0.4,0,0.7,0.3,0.7,0.7l0,0 c0,0.4-0.3,0.7-0.7,0.7H-5.9C-6.3-2.4-6.7-2.8-6.7-3.2z" />
          <path d="M-9.4-3c-0.1-0.1-0.1-0.3,0-0.4c0,0,0,0,0,0l3.7-3.1c0.1-0.1,0.3-0.1,0.4,0 c0,0.1,0.1,0.1,0.1,0.2v6.2c0,0.2-0.1,0.3-0.3,0.3c-0.1,0-0.1,0-0.2-0.1L-9.4-3z" />
        </g>
      </g>
    </svg>
  );
};

export const ATicon = (props) => {
  // <circle cx="23.5" cy="23.5" r="23" stroke="currentColor" fill="currentColor" fillOpacity="0.2" strokeWidth="1"/>
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="3 2 42 42"
      fill={"none"}
      fillRule="evenodd"
      clipRule="evenodd"
      {...props}
    >
      <g>
        <path
          fill={"currentColor"}
          d="M21 17.5C21 18.33 21.67 19 22.5 19H26V29.5C26 30.33 26.67 31 27.5 31C28.33 31 29 30.33 29 29.5V19H32.5C33.33 19 34 18.33 34 17.5C34 16.67 33.33 16 32.5 16H22.5C21.67 16 21 16.67 21 17.5ZM16.5 24H18V29.5C18 30.33 18.67 31 19.5 31C20.33 31 21 30.33 21 29.5V24H22.5C23.33 24 24 23.33 24 22.5C24 21.67 23.33 21 22.5 21H16.5C15.67 21 15 21.67 15 22.5C15 23.33 15.67 24 16.5 24Z"
        />
      </g>
    </svg>
  );
};

export const ADicon = (props) => {
  // <circle stroke="currentColor" strokeWidth="1" fill="currentColor" fillOpacity="0.2" cx="23.5" cy="23.5" r="23"/>
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="3 3 42 42"
      {...props}
    >
      <g>
        <path
          fill="currentColor"
          d="M18.34 19.93C15.22 23.05 15.22 28.12 18.34 31.24C19.9 32.8 21.95 33.58 24 33.58C26.05 33.58 28.1 32.8 29.66 31.24C32.78 28.12 32.78 23.05 29.66 19.93L24.71 14.98C24.32 14.59 23.69 14.59 23.3 14.98L18.34 19.93ZM24 31.59C22.4 31.59 20.89 30.97 19.76 29.83C18.62 28.69 18 27.19 18 25.59C18 23.99 18.62 22.48 19.76 21.35L24 17.1V31.59Z"
        />
      </g>
    </svg>
  );
};

export const ADiconOld = (props) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 25 25"
      {...props}
    >
      <g transform="translate(17.971) rotate(90)">
        <g transform="translate(0 0)">
          <circle
            stroke="currentcolor"
            fill={"transparent"}
            cx="12.5"
            cy="5.5"
            r="9"
          />
          <path
            fill="currentcolor"
            d="M21.5,5.5c0,5-4,9-9,9s-9-4-9-9s4-9,9-9S21.5,0.5,21.5,5.5z M4.5,5.5c0,4.4,3.6,8,8,8s8-3.6,8-8s-3.6-8-8-8,S4.5,1.1,4.5,5.5z"
          />
        </g>
        <g>
          <path
            fill="currentcolor"
            d="M21.5,5.5L21.5,5.5c-0.1,5-4.1,8.9-9.1,8.9c-4.9-0.1-8.8-4-8.9-8.9H21.5L21.5,5.5z"
          />
        </g>
      </g>
    </svg>
  );
};

export const Xlogo = (props) => {
  return (
    <svg
      id="Capa_2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 609 138.21"
      fill="currentcolor"
      {...props}
    >
      <g id="Layer_1">
        <path
          class="cls-1"
          d="m223.85,29.78h17.47c5.24,0,9.61,1.41,12.29,4.1,2.08,2.15,3.16,4.7,3.16,8v.2c0,5.51-3.02,8.47-6.38,10.28,5.04,1.95,8.4,5.04,8.4,11.22v.34c0,8.47-6.79,12.9-17,12.9h-17.94V29.78Zm23.31,13.84c0-3.43-2.42-5.24-6.58-5.24h-7.26v10.62h6.79c4.3,0,7.05-1.75,7.05-5.31v-.07Zm-5.31,13.57h-8.53v11.02h8.73c4.37,0,7.12-1.88,7.12-5.51v-.07c0-3.36-2.49-5.44-7.32-5.44Z"
        />
        <path
          class="cls-1"
          d="m263.29,40.8h9.54v6.38c1.75-4.37,4.64-7.26,9.74-6.99v10.35h-.4c-5.85,0-9.34,3.63-9.34,11.15v15.12h-9.54v-36.01Z"
        />
        <path
          class="cls-1"
          d="m283.04,66.54v-.4c0-7.93,5.17-11.49,12.56-11.49,3.02,0,5.31.61,7.52,1.48v-1.08c0-4.17-2.49-6.32-6.79-6.32-3.36,0-6.05,1.07-8.26,2.02l-2.62-7.46c3.49-1.75,7.12-2.89,12.3-2.89,4.9,0,8.6,1.34,10.95,3.7,2.49,2.49,3.7,6.25,3.7,10.89v21.84h-9.34v-3.9c-2.15,2.82-5.11,4.57-9.34,4.57-5.91,0-10.68-3.96-10.68-10.95Zm20.22-1.55v-3.02c-1.41-.67-3.36-1.14-5.31-1.14-3.49,0-5.71,1.75-5.71,5.04v.13c0,2.96,1.88,4.43,4.64,4.5,3.69.07,6.38-2.22,6.38-5.51Z"
        />
        <path
          class="cls-1"
          d="m318.05,40.8h9.54v4.84c2.08-2.89,4.7-5.51,9.27-5.51,6.72,0,10.62,4.7,10.62,12.16v24.52h-9.54v-21.7c0-4.23-1.88-6.38-5.11-6.38s-5.24,2.15-5.24,6.38v21.7h-9.54v-36.01Z"
        />
        <path
          class="cls-1"
          d="m351.91,59.35v-1.08c0-12.29,6.52-18.14,13.71-18.14,4.84,0,7.66,2.62,9.74,5.31v-17.13h9.54v48.51h-9.54v-4.97c-2.08,3.02-4.97,5.64-9.74,5.64-7.12,0-13.71-5.85-13.71-18.14Zm23.58-.2v-.67c0-6.11-3.09-10.01-7.05-10.01s-6.99,3.9-6.99,10.01v.67c0,6.11,3.02,10.01,6.99,10.01s7.05-3.9,7.05-10.01Z"
        />
        <path
          class="cls-1"
          d="m223.52,114.23v-.6c0-13.91,9.2-23.92,21.97-23.92,6.58,0,11.09,1.88,15.39,5.51l-5.78,7.59c-2.48-2.28-5.24-4.03-9.74-4.03-6.72,0-11.82,6.12-11.82,14.78v.54c0,9.68,5.31,15.12,12.23,15.12,2.75,0,5.24-.67,6.99-1.95v-8.33h-8.53v-8.47h17.8v21.77c-4.3,3.22-9.74,5.85-16.73,5.85-12.63,0-21.77-9.14-21.77-23.85Z"
        />
        <path
          class="cls-1"
          d="m266.38,127.13v-.4c0-7.93,5.17-11.49,12.56-11.49,3.02,0,5.31.61,7.52,1.48v-1.08c0-4.17-2.49-6.32-6.79-6.32-3.36,0-6.05,1.07-8.26,2.02l-2.62-7.46c3.49-1.75,7.12-2.89,12.3-2.89,4.9,0,8.6,1.34,10.95,3.7,2.49,2.49,3.7,6.25,3.7,10.89v21.84h-9.34v-3.9c-2.15,2.82-5.11,4.57-9.34,4.57-5.91,0-10.68-3.96-10.68-10.95Zm20.22-1.55v-3.02c-1.41-.67-3.36-1.14-5.31-1.14-3.49,0-5.71,1.75-5.71,5.04v.13c0,2.96,1.88,4.43,4.64,4.5,3.69.07,6.38-2.22,6.38-5.51Z"
        />
        <path
          class="cls-1"
          d="m301.39,101.39h9.54v4.84c2.15-3.02,4.84-5.51,9.34-5.51,4.17,0,7.19,2.02,8.87,5.24,2.62-3.16,5.85-5.24,10.21-5.24,6.38,0,10.68,4.17,10.68,12.09v24.59h-9.47v-21.7c0-4.17-1.81-6.38-4.97-6.38s-5.11,2.22-5.11,6.38v21.7h-9.54v-21.7c0-4.17-1.75-6.38-4.91-6.38s-5.11,2.22-5.11,6.38v21.7h-9.54v-36.01Z"
        />
        <path
          class="cls-1"
          d="m356.02,88.9h9.94v8.67h-9.94v-8.67Zm.2,12.5h9.54v36.01h-9.54v-36.01Z"
        />
        <path
          class="cls-1"
          d="m373.62,109.46h-3.63v-7.79h3.63v-2.42c0-3.7.94-6.32,2.69-8.06,1.81-1.81,4.43-2.69,7.86-2.69,2.62,0,4.37.34,5.91.81v7.86c-1.14-.34-2.15-.61-3.49-.61-2.22,0-3.49,1.14-3.49,3.7v1.41h6.99v7.79h-6.92v27.95h-9.54v-27.95Zm21.3-20.56h9.94v8.67h-9.94v-8.67Zm.2,12.5h9.54v36.01h-9.54v-36.01Z"
        />
        <path
          class="cls-1"
          d="m409.57,119.94v-.81c0-10.68,6.92-18.41,16.66-18.41,5.17,0,8.67,1.75,11.76,4.84l-5.17,6.92c-1.75-1.81-3.56-3.22-6.45-3.22-4.37,0-7.32,4.17-7.32,10.01v.27c0,5.98,2.75,10.15,7.52,10.15,2.82,0,4.64-1.34,6.52-3.29l5.04,6.32c-2.96,3.29-6.58,5.51-12.23,5.51-9.54,0-16.33-7.66-16.33-18.28Z"
        />
        <path
          class="cls-1"
          d="m439.94,127.13v-.4c0-7.93,5.17-11.49,12.56-11.49,3.02,0,5.31.61,7.52,1.48v-1.08c0-4.17-2.49-6.32-6.79-6.32-3.36,0-6.05,1.07-8.26,2.02l-2.62-7.46c3.49-1.75,7.12-2.89,12.3-2.89,4.9,0,8.6,1.34,10.95,3.7,2.49,2.49,3.7,6.25,3.7,10.89v21.84h-9.34v-3.9c-2.15,2.82-5.11,4.57-9.34,4.57-5.91,0-10.68-3.96-10.68-10.95Zm20.22-1.55v-3.02c-1.41-.67-3.36-1.14-5.31-1.14-3.49,0-5.71,1.75-5.71,5.04v.13c0,2.96,1.88,4.43,4.64,4.5,3.69.07,6.38-2.22,6.38-5.51Z"
        />
        <path
          class="cls-1"
          d="m476.09,128.4v-18.95h-3.63v-8.06h3.63v-9.2h9.54v9.2h7.12v8.06h-7.12v17c0,2.08.94,3.09,2.96,3.09,1.48,0,2.89-.4,4.1-1.01v7.59c-1.88,1.08-4.17,1.88-7.05,1.88-5.51,0-9.54-2.15-9.54-9.61Z"
        />
        <path
          class="cls-1"
          d="m497.46,88.9h9.94v8.67h-9.94v-8.67Zm.2,12.5h9.54v36.01h-9.54v-36.01Z"
        />
        <path
          class="cls-1"
          d="m512.17,119.87v-.74c0-10.68,7.26-18.41,17-18.41s16.86,7.59,16.86,18.34v.74c0,10.68-7.19,18.41-16.93,18.41s-16.93-7.59-16.93-18.34Zm24.46-.13v-.47c0-5.85-2.96-10.28-7.53-10.28s-7.52,4.37-7.52,10.21v.47c0,5.78,3.02,10.28,7.59,10.28s7.46-4.37,7.46-10.21Z"
        />
        <path
          class="cls-1"
          d="m550.67,101.39h9.54v4.84c2.08-2.89,4.7-5.51,9.27-5.51,6.72,0,10.62,4.7,10.62,12.16v24.52h-9.54v-21.7c0-4.23-1.88-6.38-5.11-6.38s-5.24,2.15-5.24,6.38v21.7h-9.54v-36.01Z"
        />
        <rect class="cls-1" x="169.62" y="28.65" width="6.74" height="108.63" />
        <polygon
          class="cls-1"
          points="0 137.28 32.49 137.28 48.96 112.08 32.72 87.2 0 137.28"
        />
        <polygon
          class="cls-1"
          points="122.2 0 89.7 0 52.42 57.06 33.95 28.76 1.46 28.76 52.4 106.82 122.2 0"
        />
        <polygon
          class="cls-1"
          points="55.86 112.12 72.28 137.28 104.77 137.28 72.11 87.24 55.86 112.12"
        />
        <path
          class="cls-1"
          d="m589.19,91.98h-2.91v-2.72h8.84v2.72h-2.91v9.04h-3.02v-9.04Z"
        />
        <path
          class="cls-1"
          d="m598.01,89.26h3.11l2.39,4.34,2.37-4.34h3.13v11.76h-2.99v-6.62l-2.5,4.37h-.05l-2.5-4.33v6.59h-2.94v-11.76Z"
        />
      </g>
    </svg>
  );
};

export const BGlogo = (props) => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 526.71 104.6"
      {...props}
    >
      <g>
        <g>
          <g>
            <g>
              <path
                class="st0"
                d="M225.48,12.57h14.83c4.45,0,8.15,1.2,10.44,3.48c1.77,1.83,2.68,3.99,2.68,6.79v0.17
					c0,4.68-2.57,7.19-5.42,8.73c4.28,1.65,7.13,4.28,7.13,9.52v0.28c0,7.19-5.76,10.95-14.43,10.95h-15.23V12.57z M245.27,24.32
					c0-2.91-2.05-4.45-5.59-4.45h-6.16v9.01h5.76c3.65,0,5.99-1.48,5.99-4.5V24.32z M240.76,35.84h-7.24v9.35h7.41
					c3.71,0,6.05-1.6,6.05-4.68v-0.06C246.98,37.6,244.87,35.84,240.76,35.84z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M258.95,21.92h8.1v5.42c1.48-3.71,3.94-6.16,8.27-5.93v8.78h-0.34c-4.96,0-7.93,3.08-7.93,9.47v12.83h-8.1
					V21.92z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M275.72,43.76v-0.34c0-6.73,4.39-9.75,10.66-9.75c2.57,0,4.5,0.51,6.39,1.25v-0.91
					c0-3.54-2.11-5.36-5.76-5.36c-2.85,0-5.13,0.91-7.01,1.71l-2.22-6.33c2.97-1.48,6.05-2.45,10.44-2.45c4.16,0,7.3,1.14,9.3,3.14
					c2.11,2.11,3.14,5.3,3.14,9.24v18.53h-7.93v-3.31c-1.82,2.39-4.33,3.88-7.93,3.88C279.77,53.06,275.72,49.69,275.72,43.76z
					 M292.89,42.45v-2.57c-1.2-0.57-2.85-0.97-4.5-0.97c-2.97,0-4.85,1.48-4.85,4.28v0.11c0,2.51,1.6,3.76,3.94,3.82
					C290.61,47.18,292.89,45.25,292.89,42.45z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M305.43,21.92h8.1v4.11c1.77-2.45,3.99-4.68,7.87-4.68c5.7,0,9.01,3.99,9.01,10.32v20.82h-8.1V34.07
					c0-3.59-1.6-5.42-4.33-5.42c-2.68,0-4.45,1.82-4.45,5.42v18.42h-8.1V21.92z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M334.18,37.66v-0.91c0-10.44,5.53-15.4,11.63-15.4c4.11,0,6.5,2.22,8.27,4.5V11.31h8.1v41.17h-8.1v-4.22
					c-1.77,2.57-4.22,4.79-8.27,4.79C339.76,53.06,334.18,48.1,334.18,37.66z M354.19,37.49v-0.57c0-5.19-2.62-8.5-5.99-8.5
					c-3.36,0-5.93,3.31-5.93,8.5v0.57c0,5.19,2.57,8.5,5.93,8.5C351.57,45.99,354.19,42.68,354.19,37.49z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M224.05,84.24v-0.51c0-11.81,7.81-20.3,18.65-20.3c5.59,0,9.41,1.6,13.06,4.68l-4.9,6.44
					c-2.11-1.94-4.45-3.42-8.27-3.42c-5.7,0-10.04,5.19-10.04,12.55v0.46c0,8.21,4.5,12.83,10.38,12.83c2.34,0,4.45-0.57,5.93-1.65
					v-7.07h-7.24v-7.19h15.11v18.48c-3.65,2.74-8.27,4.96-14.2,4.96C231.81,104.49,224.05,96.73,224.05,84.24z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M260.44,95.19v-0.34c0-6.73,4.39-9.75,10.66-9.75c2.57,0,4.5,0.51,6.39,1.25v-0.91
					c0-3.54-2.11-5.36-5.76-5.36c-2.85,0-5.13,0.91-7.01,1.71l-2.22-6.33c2.97-1.48,6.05-2.45,10.44-2.45c4.16,0,7.3,1.14,9.3,3.14
					c2.11,2.11,3.14,5.3,3.14,9.24v18.53h-7.93v-3.31c-1.82,2.39-4.33,3.88-7.93,3.88C264.48,104.49,260.44,101.12,260.44,95.19z
					 M277.6,93.88v-2.57c-1.2-0.57-2.85-0.97-4.5-0.97c-2.97,0-4.85,1.48-4.85,4.28v0.11c0,2.51,1.6,3.76,3.94,3.82
					C275.32,98.61,277.6,96.67,277.6,93.88z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M290.15,73.35h8.1v4.11c1.83-2.57,4.11-4.68,7.93-4.68c3.54,0,6.1,1.71,7.53,4.45
					c2.22-2.68,4.96-4.45,8.67-4.45c5.42,0,9.07,3.54,9.07,10.26v20.87h-8.04V85.5c0-3.54-1.54-5.42-4.22-5.42
					c-2.68,0-4.33,1.88-4.33,5.42v18.42h-8.1V85.5c0-3.54-1.48-5.42-4.16-5.42c-2.68,0-4.33,1.88-4.33,5.42v18.42h-8.1V73.35z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M336.51,62.74h8.44v7.36h-8.44V62.74z M336.69,73.35h8.1v30.57h-8.1V73.35z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M351.46,80.19h-3.08v-6.62h3.08v-2.05c0-3.14,0.8-5.36,2.28-6.84c1.54-1.54,3.76-2.28,6.67-2.28
					c2.22,0,3.71,0.29,5.02,0.68v6.67c-0.97-0.29-1.83-0.51-2.97-0.51c-1.88,0-2.97,0.97-2.97,3.14v1.2h5.93v6.62h-5.87v23.72h-8.1
					V80.19z M369.53,62.74h8.44v7.36h-8.44V62.74z M369.7,73.35h8.1v30.57h-8.1V73.35z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M381.97,89.09V88.4c0-9.07,5.87-15.62,14.14-15.62c4.39,0,7.36,1.48,9.98,4.11l-4.39,5.87
					c-1.48-1.54-3.02-2.74-5.47-2.74c-3.71,0-6.22,3.54-6.22,8.5v0.23c0,5.08,2.34,8.61,6.39,8.61c2.39,0,3.93-1.14,5.53-2.79
					l4.28,5.36c-2.51,2.79-5.59,4.68-10.38,4.68C387.73,104.6,381.97,98.1,381.97,89.09z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M407.74,95.19v-0.34c0-6.73,4.39-9.75,10.66-9.75c2.57,0,4.5,0.51,6.39,1.25v-0.91
					c0-3.54-2.11-5.36-5.76-5.36c-2.85,0-5.13,0.91-7.01,1.71l-2.22-6.33c2.97-1.48,6.05-2.45,10.44-2.45c4.16,0,7.3,1.14,9.3,3.14
					c2.11,2.11,3.14,5.3,3.14,9.24v18.53h-7.93v-3.31c-1.82,2.39-4.33,3.88-7.93,3.88C411.79,104.49,407.74,101.12,407.74,95.19z
					 M424.91,93.88v-2.57c-1.2-0.57-2.85-0.97-4.5-0.97c-2.97,0-4.85,1.48-4.85,4.28v0.11c0,2.51,1.6,3.76,3.94,3.82
					C422.63,98.61,424.91,96.67,424.91,93.88z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M438.43,96.27V80.19h-3.08v-6.84h3.08v-7.81h8.1v7.81h6.04v6.84h-6.04v14.43c0,1.77,0.8,2.62,2.51,2.62
					c1.25,0,2.45-0.34,3.48-0.86v6.44c-1.6,0.91-3.54,1.6-5.99,1.6C441.85,104.43,438.43,102.6,438.43,96.27z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M456.56,62.74H465v7.36h-8.44V62.74z M456.73,73.35h8.1v30.57h-8.1V73.35z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M469.05,89.03V88.4c0-9.07,6.16-15.62,14.43-15.62c8.27,0,14.31,6.44,14.31,15.57v0.63
					c0,9.07-6.1,15.63-14.37,15.63C475.15,104.6,469.05,98.16,469.05,89.03z M489.81,88.92v-0.4c0-4.96-2.51-8.73-6.39-8.73
					c-4.05,0-6.39,3.71-6.39,8.67v0.4c0,4.9,2.57,8.73,6.44,8.73C487.47,97.59,489.81,93.88,489.81,88.92z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M501.73,73.35h8.1v4.11c1.77-2.45,3.99-4.68,7.87-4.68c5.7,0,9.01,3.99,9.01,10.32v20.82h-8.1V85.5
					c0-3.59-1.6-5.42-4.33-5.42c-2.68,0-4.45,1.82-4.45,5.42v18.42h-8.1V73.35z"
              />
            </g>
          </g>
        </g>
        <g>
          <rect x="184.48" y="11.47" class="st0" width="5" height="92.37" />
        </g>
        <g>
          <g>
            <g>
              <path
                class="st0"
                d="M10.48,36.22c0,5.52,3.38,9.55,9.39,9.55c4.69,0,7-1.32,9.71-4.03l6.5,6.34c-4.36,4.36-8.56,6.75-16.3,6.75
					c-10.13,0-19.84-4.61-19.84-21.98c0-14,7.57-21.9,18.69-21.9c11.94,0,18.69,8.73,18.69,20.5v4.78H10.48z M25.79,24.29
					c-1.15-2.55-3.54-4.45-7.16-4.45c-3.62,0-6.01,1.89-7.16,4.45c-0.66,1.56-0.91,2.72-0.99,4.61h16.3
					C26.7,27,26.45,25.85,25.79,24.29z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M57.52,54.34c-8.73,0-12.43-6.17-12.43-12.27V20.83h-4.53v-8.15h4.53V0h10.7v12.68h7.57v8.15h-7.57v20.58
					c0,2.47,1.15,3.87,3.7,3.87h3.87v9.06H57.52z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M77.15,36.22c0,5.52,3.38,9.55,9.39,9.55c4.69,0,7-1.32,9.71-4.03l6.5,6.34c-4.36,4.36-8.56,6.75-16.3,6.75
					c-10.13,0-19.84-4.61-19.84-21.98c0-14,7.57-21.9,18.69-21.9c11.94,0,18.69,8.73,18.69,20.5v4.78H77.15z M92.46,24.29
					c-1.15-2.55-3.54-4.45-7.16-4.45c-3.62,0-6.01,1.89-7.16,4.45c-0.66,1.56-0.91,2.72-0.99,4.61h16.3
					C93.37,27,93.12,25.85,92.46,24.29z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                class="st0"
                d="M49.89,103.95V78.02c0-5.84-3.7-7.82-7.08-7.82c-3.29,0-7.16,1.98-7.16,7.57v26.18h-10.7V78.02
					c0-5.84-3.7-7.82-7.08-7.82c-3.38,0-7.16,1.98-7.16,7.82v25.93H0V61.06h10.46v3.95c2.8-2.88,6.75-4.45,10.7-4.45
					c4.78,0,8.64,1.73,11.36,5.43c3.62-3.79,7.49-5.43,12.84-5.43c4.28,0,8.15,1.4,10.54,3.79c3.46,3.46,4.69,7.49,4.69,12.18v27.42
					H49.89z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M89.5,103.95v-3.7c-2.88,2.88-5.6,4.12-10.54,4.12c-4.86,0-8.4-1.23-10.95-3.79
					c-2.31-2.39-3.54-5.84-3.54-9.63c0-6.83,4.69-12.43,14.65-12.43h10.13v-2.14c0-4.69-2.31-6.75-7.99-6.75
					c-4.12,0-6.01,0.99-8.23,3.54l-6.83-6.67c4.2-4.61,8.32-5.93,15.48-5.93c12.02,0,18.28,5.1,18.28,15.15v28.24H89.5z
					 M89.25,85.84h-8.48c-3.87,0-6.01,1.81-6.01,4.86c0,2.96,1.98,4.94,6.18,4.94c2.96,0,4.86-0.25,6.75-2.06
					c1.15-1.07,1.56-2.8,1.56-5.43V85.84z"
              />
            </g>
          </g>
          <g>
            <path
              class="st0"
              d="M114.53,84.15l6.42,9.84l-6.51,9.96h-12.85L114.53,84.15z M149.91,49.67h-12.85l-14.74,22.56l-7.3-11.19
				h-12.85l20.14,30.87L149.91,49.67z M123.68,94l6.49,9.95h12.85l-12.91-19.79L123.68,94z"
            />
          </g>
          <g>
            <g>
              <path
                class="st0"
                d="M130.38,10.98c-4.61,0-8.72,2.14-10.78,4.61v-4.11h-10.45v42.86h10.7V28.5c0-5.43,3.62-7.9,6.91-7.9
					c2.12,0,3.44,0.6,4.74,1.69c0,0,0.52-0.67,7.11-8.91c-0.32-0.23-0.64-0.44-0.96-0.64C135.54,11.48,133.25,10.98,130.38,10.98z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const EtermaxBG = (props) => {
  return (
    <svg
      id="Capa_2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 651.2 123.57"
      fill={"currentColor"}
      {...props}
    >
      <g id="Layer_1">
        <path
          class="cls-1"
          d="m264.75,14.85h17.52c5.26,0,9.63,1.41,12.33,4.11,2.09,2.16,3.17,4.72,3.17,8.02v.2c0,5.52-3.03,8.49-6.4,10.31,5.05,1.95,8.42,5.05,8.42,11.25v.34c0,8.49-6.8,12.93-17.04,12.93h-17.99V14.85Zm23.38,13.88c0-3.44-2.42-5.26-6.6-5.26h-7.28v10.64h6.8c4.31,0,7.07-1.75,7.07-5.32v-.07Zm-5.32,13.61h-8.56v11.05h8.76c4.38,0,7.14-1.89,7.14-5.52v-.07c0-3.37-2.49-5.46-7.34-5.46Z"
        />
        <path
          class="cls-1"
          d="m304.3,25.9h9.57v6.4c1.75-4.38,4.65-7.28,9.77-7.01v10.38h-.4c-5.86,0-9.37,3.64-9.37,11.18v15.16h-9.57V25.9Z"
        />
        <path
          class="cls-1"
          d="m324.11,51.7v-.4c0-7.95,5.19-11.52,12.6-11.52,3.03,0,5.32.61,7.55,1.48v-1.08c0-4.18-2.49-6.33-6.8-6.33-3.37,0-6.06,1.08-8.29,2.02l-2.63-7.48c3.5-1.75,7.14-2.9,12.33-2.9,4.92,0,8.62,1.35,10.98,3.71,2.49,2.49,3.71,6.27,3.71,10.91v21.89h-9.37v-3.91c-2.16,2.83-5.12,4.58-9.36,4.58-5.93,0-10.71-3.98-10.71-10.98Zm20.28-1.55v-3.03c-1.41-.67-3.37-1.15-5.32-1.15-3.5,0-5.73,1.75-5.73,5.05v.13c0,2.96,1.89,4.45,4.65,4.51,3.7.07,6.4-2.22,6.4-5.52Z"
        />
        <path
          class="cls-1"
          d="m359.21,25.9h9.57v4.85c2.09-2.9,4.72-5.52,9.3-5.52,6.74,0,10.64,4.71,10.64,12.19v24.59h-9.57v-21.76c0-4.24-1.89-6.4-5.12-6.4s-5.26,2.16-5.26,6.4v21.76h-9.57V25.9Z"
        />
        <path
          class="cls-1"
          d="m393.17,44.49v-1.08c0-12.33,6.53-18.19,13.74-18.19,4.85,0,7.68,2.63,9.77,5.32V13.37h9.57v48.64h-9.57v-4.99c-2.09,3.03-4.98,5.66-9.77,5.66-7.14,0-13.74-5.86-13.74-18.19Zm23.65-.2v-.67c0-6.13-3.1-10.04-7.07-10.04s-7.01,3.91-7.01,10.04v.67c0,6.13,3.03,10.04,7.01,10.04s7.07-3.91,7.07-10.04Z"
        />
        <path
          class="cls-1"
          d="m264.75,99.52v-.61c0-13.95,9.23-23.98,22.03-23.98,6.6,0,11.12,1.89,15.43,5.52l-5.79,7.61c-2.49-2.29-5.25-4.04-9.77-4.04-6.74,0-11.86,6.13-11.86,14.82v.54c0,9.7,5.32,15.16,12.26,15.16,2.76,0,5.26-.67,7.01-1.95v-8.35h-8.56v-8.49h17.85v21.83c-4.31,3.23-9.77,5.86-16.77,5.86-12.67,0-21.83-9.16-21.83-23.92Z"
        />
        <path
          class="cls-1"
          d="m307.74,112.45v-.4c0-7.95,5.19-11.52,12.6-11.52,3.03,0,5.32.61,7.55,1.48v-1.08c0-4.18-2.49-6.33-6.8-6.33-3.37,0-6.06,1.08-8.29,2.02l-2.63-7.48c3.5-1.75,7.14-2.9,12.33-2.9,4.92,0,8.62,1.35,10.98,3.71,2.49,2.49,3.71,6.27,3.71,10.91v21.89h-9.37v-3.91c-2.16,2.83-5.12,4.58-9.36,4.58-5.93,0-10.71-3.98-10.71-10.98Zm20.28-1.55v-3.03c-1.41-.67-3.37-1.15-5.32-1.15-3.5,0-5.73,1.75-5.73,5.05v.13c0,2.96,1.89,4.45,4.65,4.51,3.7.07,6.4-2.22,6.4-5.52Z"
        />
        <path
          class="cls-1"
          d="m342.84,86.65h9.57v4.85c2.16-3.03,4.85-5.52,9.37-5.52,4.18,0,7.21,2.02,8.89,5.25,2.63-3.17,5.86-5.25,10.24-5.25,6.4,0,10.71,4.18,10.71,12.13v24.66h-9.5v-21.76c0-4.18-1.82-6.4-4.99-6.4s-5.12,2.22-5.12,6.4v21.76h-9.57v-21.76c0-4.18-1.75-6.4-4.92-6.4s-5.12,2.22-5.12,6.4v21.76h-9.57v-36.11Z"
        />
        <path
          class="cls-1"
          d="m397.61,74.12h9.97v8.69h-9.97v-8.69Zm.2,12.53h9.57v36.11h-9.57v-36.11Z"
        />
        <path
          class="cls-1"
          d="m415.26,94.74h-3.64v-7.82h3.64v-2.42c0-3.71.94-6.33,2.7-8.08,1.82-1.82,4.45-2.7,7.88-2.7,2.63,0,4.38.34,5.93.81v7.88c-1.15-.34-2.16-.61-3.5-.61-2.22,0-3.5,1.15-3.5,3.71v1.41h7.01v7.82h-6.94v28.03h-9.57v-28.03Zm21.36-20.62h9.97v8.69h-9.97v-8.69Zm.2,12.53h9.57v36.11h-9.57v-36.11Z"
        />
        <path
          class="cls-1"
          d="m451.31,105.25v-.81c0-10.71,6.94-18.46,16.71-18.46,5.19,0,8.69,1.75,11.79,4.85l-5.19,6.94c-1.75-1.82-3.57-3.23-6.47-3.23-4.38,0-7.34,4.18-7.34,10.04v.27c0,6,2.76,10.17,7.55,10.17,2.83,0,4.65-1.35,6.53-3.3l5.05,6.33c-2.96,3.3-6.6,5.52-12.26,5.52-9.57,0-16.37-7.68-16.37-18.32Z"
        />
        <path
          class="cls-1"
          d="m481.76,112.45v-.4c0-7.95,5.19-11.52,12.6-11.52,3.03,0,5.32.61,7.55,1.48v-1.08c0-4.18-2.49-6.33-6.8-6.33-3.37,0-6.06,1.08-8.29,2.02l-2.63-7.48c3.5-1.75,7.14-2.9,12.33-2.9,4.92,0,8.62,1.35,10.98,3.71,2.49,2.49,3.71,6.27,3.71,10.91v21.89h-9.37v-3.91c-2.16,2.83-5.12,4.58-9.36,4.58-5.93,0-10.71-3.98-10.71-10.98Zm20.28-1.55v-3.03c-1.41-.67-3.37-1.15-5.32-1.15-3.5,0-5.73,1.75-5.73,5.05v.13c0,2.96,1.89,4.45,4.65,4.51,3.7.07,6.4-2.22,6.4-5.52Z"
        />
        <path
          class="cls-1"
          d="m518.01,113.73v-19h-3.64v-8.09h3.64v-9.23h9.57v9.23h7.14v8.09h-7.14v17.04c0,2.09.94,3.1,2.96,3.1,1.48,0,2.9-.4,4.11-1.01v7.61c-1.89,1.08-4.18,1.89-7.07,1.89-5.52,0-9.57-2.16-9.57-9.63Z"
        />
        <path
          class="cls-1"
          d="m539.43,74.12h9.97v8.69h-9.97v-8.69Zm.2,12.53h9.57v36.11h-9.57v-36.11Z"
        />
        <path
          class="cls-1"
          d="m554.18,105.18v-.74c0-10.71,7.28-18.46,17.04-18.46s16.91,7.61,16.91,18.39v.74c0,10.71-7.21,18.46-16.98,18.46s-16.98-7.61-16.98-18.39Zm24.52-.13v-.47c0-5.86-2.96-10.31-7.55-10.31s-7.55,4.38-7.55,10.24v.47c0,5.79,3.03,10.31,7.61,10.31s7.48-4.38,7.48-10.24Z"
        />
        <path
          class="cls-1"
          d="m592.79,86.65h9.57v4.85c2.09-2.9,4.72-5.52,9.3-5.52,6.74,0,10.64,4.71,10.64,12.19v24.59h-9.57v-21.76c0-4.24-1.89-6.4-5.12-6.4s-5.26,2.16-5.26,6.4v21.76h-9.57v-36.11Z"
        />
        <rect class="cls-1" x="218.01" y="13.55" width="5.91" height="109.13" />
        <path
          class="cls-1"
          d="m12.45,42.79c0,6.52,3.99,11.28,11.09,11.28,5.54,0,8.27-1.56,11.48-4.77l7.68,7.49c-5.16,5.16-10.12,7.98-19.26,7.98-11.96,0-23.44-5.45-23.44-25.97C0,22.27,8.95,12.94,22.08,12.94c14.1,0,22.08,10.31,22.08,24.22v5.64H12.45Zm18.09-14.1c-1.36-3.02-4.18-5.25-8.46-5.25s-7.1,2.24-8.46,5.25c-.78,1.85-1.07,3.21-1.17,5.45h19.26c-.1-2.24-.39-3.6-1.17-5.45Z"
        />
        <path
          class="cls-1"
          d="m68.02,64.19c-10.31,0-14.69-7.29-14.69-14.49v-25.09h-5.35v-9.63h5.35V0h12.64v14.98h8.95v9.63h-8.95v24.32c0,2.92,1.36,4.57,4.38,4.57h4.57v10.7h-6.9Z"
        />
        <path
          class="cls-1"
          d="m91.21,42.79c0,6.52,3.99,11.28,11.09,11.28,5.54,0,8.27-1.56,11.48-4.77l7.68,7.49c-5.15,5.16-10.11,7.98-19.26,7.98-11.96,0-23.44-5.45-23.44-25.97,0-16.53,8.95-25.87,22.08-25.87,14.1,0,22.08,10.31,22.08,24.22v5.64h-31.71Zm18.09-14.1c-1.36-3.02-4.18-5.25-8.46-5.25s-7.1,2.24-8.46,5.25c-.78,1.85-1.07,3.21-1.17,5.45h19.26c-.1-2.24-.39-3.6-1.17-5.45Z"
        />
        <path
          class="cls-1"
          d="m59.01,122.81v-30.64c0-6.9-4.38-9.24-8.36-9.24s-8.46,2.33-8.46,8.95v30.93h-12.64v-30.64c0-6.9-4.38-9.24-8.36-9.24s-8.46,2.33-8.46,9.24v30.64H.07v-50.67h12.35v4.67c3.31-3.4,7.98-5.25,12.64-5.25,5.64,0,10.21,2.04,13.42,6.42,4.28-4.47,8.85-6.42,15.17-6.42,5.06,0,9.63,1.65,12.45,4.47,4.08,4.08,5.54,8.85,5.54,14.39v32.39h-12.64Z"
        />
        <path
          class="cls-1"
          d="m105.8,122.81v-4.38c-3.4,3.4-6.61,4.86-12.45,4.86s-9.92-1.46-12.94-4.47c-2.72-2.82-4.18-6.9-4.18-11.38,0-8.07,5.54-14.69,17.31-14.69h11.96v-2.53c0-5.54-2.72-7.98-9.43-7.98-4.86,0-7.1,1.17-9.73,4.18l-8.07-7.88c4.96-5.45,9.82-7,18.29-7,14.2,0,21.59,6.03,21.59,17.9v33.36h-12.35Zm-.29-21.4h-10.02c-4.57,0-7.1,2.14-7.1,5.74s2.33,5.84,7.3,5.84c3.5,0,5.74-.29,7.98-2.43,1.36-1.26,1.85-3.31,1.85-6.42v-2.72Z"
        />
        <path
          class="cls-1"
          d="m135.37,99.41l7.58,11.62-7.69,11.77h-15.18l15.29-23.39Zm41.79-40.73h-15.18l-17.42,26.65-8.63-13.22h-15.18l23.8,36.46,32.6-49.9Zm-30.99,52.37l7.67,11.75h15.18l-15.26-23.38-7.59,11.62Z"
        />
        <path
          class="cls-1"
          d="m154.09,12.97c-5.44,0-10.3,2.53-12.73,5.44v-4.86h-12.34v50.64h12.63v-30.52c0-6.41,4.28-9.33,8.16-9.33,2.51,0,4.07.71,5.6,2,0,0,.62-.79,8.4-10.53-.38-.27-.75-.53-1.14-.75-2.49-1.49-5.2-2.08-8.58-2.08Z"
        />
        <path
          class="cls-1"
          d="m631.29,77.08h-2.92v-2.74h8.88v2.74h-2.92v9.08h-3.04v-9.08Z"
        />
        <path
          class="cls-1"
          d="m640.16,74.35h3.12l2.4,4.36,2.38-4.36h3.14v11.82h-3.01v-6.65l-2.52,4.39h-.05l-2.52-4.36v6.62h-2.96v-11.82Z"
        />
      </g>
    </svg>
  );
};

export const DropIcon = (props) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="2 2 16 16"
      fill="currentcolor"
      focusable="false"
      {...props}
    >
      <g>
        <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" />
      </g>
    </svg>
  );
};

export const ContactIcon = (props) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="-11 -11 46 46"
      fill="currentcolor"
      {...props}
    >
      <g>
        <path d="M0 3v18h24v-18h-24zm21.518 2l-9.518 7.713-9.518-7.713h19.036zm-19.518 14v-11.817l10 8.104 10-8.104v11.817h-20z" />
      </g>
    </svg>
  );
};

export const TTicon = (props) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      fill={"none"}
      fillRule="evenodd"
      clipRule="evenodd"
      {...props}
    >
      <g>
        <path
          d="M25 31V19.83L29.88 24.71C30.27 25.1 30.91 25.1 31.3 24.71C31.69 24.32 31.69 23.69 31.3 23.3L24.71 16.71C24.32 16.32 23.69 16.32 23.3 16.71L16.7 23.29C16.31 23.68 16.31 24.31 16.7 24.7C17.09 25.09 17.72 25.09 18.11 24.7L23 19.83V31C23 31.55 23.45 32 24 32C24.55 32 25 31.55 25 31Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const CPlayIcon = (props) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 96 96"
      fill={"currentColor"}
      fillRule="evenodd"
      clipRule="evenodd"
      {...props}
    >
      <g>
        <circle
          cx="47"
          cy="47"
          r="47"
          stroke="currentColor"
          fill="currentColor"
          fillOpacity="0.4"
        />
        <path
          d="M39.0002 36.6402V57.3602C39.0002 58.9402 40.7402 59.9002 42.0802 59.0402L58.3602 48.6802C59.6002 47.9002 59.6002 46.1002 58.3602 45.3002L42.0802 34.9602C40.7402 34.1002 39.0002 35.0602 39.0002 36.6402Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const RArrowIcon = (props) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 492 492"
      fill={"currentColor"}
      width={"100%"}
      height={"100%"}
      fillRule="evenodd"
      clipRule="evenodd"
      {...props}
    >
      <g>
        <path
          d="M484.14,226.886L306.46,49.202c-5.072-5.072-11.832-7.856-19.04-7.856c-7.216,0-13.972,2.788-19.044,7.856l-16.132,16.136
		c-5.068,5.064-7.86,11.828-7.86,19.04c0,7.208,2.792,14.2,7.86,19.264L355.9,207.526H26.58C11.732,207.526,0,219.15,0,234.002
		v22.812c0,14.852,11.732,27.648,26.58,27.648h330.496L252.248,388.926c-5.068,5.072-7.86,11.652-7.86,18.864
		c0,7.204,2.792,13.88,7.86,18.948l16.132,16.084c5.072,5.072,11.828,7.836,19.044,7.836c7.208,0,13.968-2.8,19.04-7.872
		l177.68-177.68c5.084-5.088,7.88-11.88,7.86-19.1C492.02,238.762,489.228,231.966,484.14,226.886z"
        />
      </g>
    </svg>
  );
};

export const BurgerIcon = (props) => {
  return (
    <div {...props}>
      <span id={"burgerTop"} className="burger-line top" />
      <span id={"burgerMid"} className="burger-line mid" />
      <span id={"burgerBot"} className="burger-line bot" />
    </div>
  );
};

export const SocialIcons = (props) => {
  const { bColor, bgColor, icon, bw, ...svgProps } = props;
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 260 260"
      {...svgProps}
    >
      <g>
        <circle
          fill={bgColor}
          strokeWidth={bw ? bw : 12}
          stroke={bColor}
          cx="130"
          cy="130"
          r="124"
        />
      </g>
      {icon === "youtube" ? (
        <path
          fill="currentColor"
          transform="translate(-180, -265)"
          d="M360.67,372.74c0.4-8.88-6.46-16.4-15.33-16.82c-11.48-0.54-23.19-0.75-35.15-0.75h-3.73
	c-11.93,0-23.67,0.2-35.15,0.75c-8.89,0.45-15.74,8-15.32,16.88c-0.51,7.36-0.72,14.74-0.72,22.12s0.21,14.75,0.71,22.15
	c-0.41,8.88,6.44,16.42,15.32,16.88c12.06,0.56,24.43,0.81,37.01,0.79s24.93-0.21,37.01-0.79c8.89-0.45,15.74-7.99,15.33-16.88
	c0.49-7.4,0.72-14.77,0.71-22.17C361.33,387.5,361.17,380.14,360.67,372.74z M298.16,415.24v-40.72l30.06,20.35L298.16,415.24z"
        />
      ) : icon === "medium" ? (
        <path
          fill="white"
          transform="scale(4) translate(13, 22)"
          d="M10.959,0A11.035,11.035,0,1,1,0,11.035,11,11,0,0,1,10.959,
                0Zm17.5.646c3.026,0,5.48,4.651,5.48,10.388h0c0,5.736-2.453,10.388-5.48,10.388s-5.48-4.652-5.48-10.388S25.435.646,28.461.646Zm8.47,
                1.082c1.064,0,1.927,4.166,1.927,9.306S38,20.341,36.931,20.341,35,16.174,35,11.035,35.867,1.728,36.931,1.728Z"
        />
      ) : icon === "linkedin" ? (
        <path
          fill="currentColor"
          transform="translate(-180, -265)"
          d="M284.93,436.6h-20.97v-67.51h20.97V436.6z M274.44,359.87c-6.74,0.03-12.22-5.4-12.26-12.14
            c-0.03-6.74,5.4-12.22,12.14-12.26c6.74-0.03,12.22,5.4,12.26,12.14C286.58,354.34,281.16,359.81,274.44,359.87z M363.4,436.6
            h-20.92v-32.87c0-7.83-0.16-17.88-10.9-17.88c-10.9,0-12.57,8.51-12.57,17.32v33.43h-20.95v-67.51h20.11v9.2h0.29
            c4.1-7.01,11.72-11.21,19.84-10.91c21.23,0,25.12,13.97,25.12,32.12v37.09L363.4,436.6z"
        />
      ) : (
        <g></g>
      )}
    </svg>
  );
};

export const Atom360 = (props) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 150 150"
      fill={"currentColor"}
      fillRule="evenodd"
      clipRule="evenodd"
      {...props}
    >
      {Atom360Fragment(0)}
    </svg>
  );
};

export const Atom360Fragment = (margin) => (
  <>
    <circle fill={"white"} fillOpacity={0.9} cx={75} cy={75} r={75 + margin} />
    <g transform="translate(62.099 62.099)">
      <path
        id="atomo"
        d="M18,21.3c0.2,0.1,0.5,0,0.6-0.3l0,0c0.2-0.6,0.4-1.2,0.5-1.8c4.4-1.1,7.3-3.3,7.3-5.9s-2.9-4.9-7.3-5.9
			C18.1,2.9,15.9,0,13.2,0S8.4,2.9,7.3,7.3C6.7,7.5,6.1,7.6,5.5,7.8C5.3,7.9,5.1,8.2,5.2,8.4c0.1,0.2,0.4,0.4,0.6,0.3l0,0
			c0.4-0.1,0.8-0.3,1.2-0.4c-0.6,3.2-0.6,6.5,0,9.8c-3.6-1-6.1-2.8-6.1-4.9c0.1-1.3,0.9-2.4,2-3.1l-0.2,0.8
			c-0.1,0.3,0.1,0.5,0.4,0.6c0,0,0,0,0,0l0,0c0,0,0.1,0,0.1,0c0.2,0,0.4-0.2,0.5-0.4l0.4-2c0-0.3-0.1-0.5-0.4-0.6h0l0,0l-2-0.4
			C1.5,8.2,1.3,8.3,1.2,8.6C1.2,8.8,1.3,9.1,1.6,9.1h0l0.9,0.2C0.9,10.4,0,11.8,0,13.2c0,2.6,2.9,4.9,7.3,5.9
			c1.1,4.4,3.3,7.3,5.9,7.3c1.5,0,2.9-1,4-2.7l0.1,0.9c0,0.2,0.2,0.4,0.5,0.4c0,0,0,0,0.1,0c0.3,0,0.4-0.3,0.4-0.5l0,0l-0.2-2
			c0-0.3-0.3-0.4-0.5-0.4l0,0l-2,0.2c-0.3,0-0.4,0.3-0.4,0.5c0,0.3,0.3,0.4,0.5,0.4l0.8-0.1c-1,1.4-2.1,2.2-3.2,2.2
			c-2,0-3.9-2.5-4.9-6.1c1.6,0.3,3.2,0.5,4.9,0.5c1.6,0,3.3-0.1,4.9-0.5c-0.1,0.4-0.2,0.8-0.4,1.2C17.7,20.9,17.8,21.2,18,21.3
			C18,21.3,18,21.3,18,21.3z M25.5,13.2c0,2-2.5,3.9-6.1,4.9c0.3-1.6,0.5-3.2,0.5-4.9c0-1.6-0.1-3.3-0.5-4.9
			C23,9.4,25.5,11.2,25.5,13.2L25.5,13.2z M13.2,0.9c2,0,3.9,2.5,4.9,6.1c-1.6-0.3-3.2-0.5-4.9-0.5c-1.6,0-3.3,0.1-4.9,0.5
			C9.4,3.4,11.2,0.9,13.2,0.9L13.2,0.9z M13.2,18.9c-1.7,0-3.4-0.2-5.1-0.5c-0.7-3.4-0.7-6.9,0-10.3c3.4-0.7,6.9-0.7,10.3,0
			c0.4,1.7,0.5,3.4,0.5,5.1c0,1.7-0.2,3.4-0.5,5.1C16.7,18.7,15,18.9,13.2,18.9L13.2,18.9z"
      />
    </g>
  </>
);
